export enum DataTypeCollection {
  'ENERGY' = 'Energy',
  'METERING' = 'METERING',
  'METERING_CAPACITIES' = 'METERING_CAPACITIES',
  'CAPACITIES' = 'CAPACITIES',
  'ALL' = 'ALL',
  'NOMINATION_ENGIE' = 'NOMINATION_ENGIE',
  'NOMINATION_CLIENT' = 'NOMINATION_CLIENT',
  'CARBON_ACCOUNTING' = 'CARBON_ACCOUNTING',
  'DOWNTIME' = 'DOWNTIME',
  pcs = 'PCS',
  volume = 'Volume',
  voltage = 'voltage',
  zNumber = 'z_number',
  downtime = 'downtime',
  activePower = 'active_power',
  capacitiveReactivePower = 'capacitive_reactive_power',
  inductiveReactivePower = 'inductive_reactive_power',
  normalizedVolume = 'NormalizedVolume',
}
